<template>
    <div>
        <h1>エラーページ</h1>
        <p>エラーが発生しました。</p>
    </div>
</template>
